// 报表api

// import { baseRequest, fileRequest, fileUploadRequest } from './base'
import newRequest from '../utils/newRequest'
import requestHeader from '../utils/requestHeader'
import { filterEmpty } from '../utils'
import { baseRequest } from './base'

/**
 * @desc 课时明细
 */
export const getStatisticalListData = (params) => {
  let afterParams = filterEmpty(params)
  return newRequest({
    url: 'api/pcWeb/report/listClassHourDetails',
    headers: requestHeader.createHeaders(afterParams),
    params: afterParams,
  })
}

/**
 * @desc 课时明细下拉框
 */
export const getReportParamsList = (params) => {
  let afterParams = filterEmpty(params)
  return newRequest({
    url: `api/pcWeb/report/classHourDetailsSelectionSource/${params}`,
    headers: requestHeader.createHeaders(params),
    params: afterParams,
  })
}

/**
 * @desc 考勤汇总
 */
export const getCollectList = (params) => {
  let afterParams = filterEmpty(params)
  return newRequest({
    url: 'api/pcWeb/report/listAttendance',
    headers: requestHeader.createHeaders(afterParams),
    params: afterParams,
  })
}



/**
 * @desc 考勤明细
 */
export const getClassHourStatistic = (params) => {
  let afterParams = filterEmpty(params)
  return newRequest({
    url: 'api/pcWeb/report/listAttendanceDetails',
    headers: requestHeader.createHeaders(afterParams),
    params: afterParams,
  })
}

/**
 * @desc 按月导出
 */
export function exportByMonth(params) {
  let afterParams = filterEmpty(params)
  let tempUrl = 'api/pcWeb/report/exportByMonth'
  return baseRequest(tempUrl, 'post', afterParams)
}

/**
 * @desc 考勤明细下拉框数据
 */
export const getSelectList = (params) => {
  let afterParams = filterEmpty(params)
  return newRequest({
    url: `api/pcWeb/report/attendanceDetailsSelectionSource/${params}`,
    headers: requestHeader.createHeaders(afterParams),
    params: afterParams,
  })
}

// deletedAttendanceDetail
/**
 * @desc 考勤明细删除内容
 */
export function deletedAttendanceDetail(params) {
  let afterParams = filterEmpty(params)
  let tempUrl = 'api/pcWeb/report/batchDelAttendanceDetails'
  return baseRequest(tempUrl, 'post', afterParams)
}

// /**
//  * @desc 查询学生列表
//  */
//  function getStudentList(params) {
//   //清除空白字段
//   params = utils.common.checkNull(params)
//   let tempUrl = '/api/pcWeb/teaStudent/'
//   return baseRequest(tempUrl, 'get', params)
// }

// /**
//  * @desc 根据学生ID获取学生信息
//  */
// function getStudentById(id) {
//   return baseRequest(`/api/pcWeb/teaStudent/${id}`, 'get')
// }

// /**
//  * @desc 导入学生信息
//  */
//  function importStudent(params) {
//   return fileRequest(`/api/pcWeb/teaStudent/importStudent`, params)
// }

// /**
//  * @desc 导出学生报班
//  */
//  function exportApplyStudent(params) {
//   return fileUploadRequest(`/api/pcWeb/teaStudent/exportApplyStudent`, params)
// }

/**
 * @desc 导出学生考勤信息列表查询表单
 */
export function studentAttendanceDetailsForm() {
  return baseRequest(`/api/pcWeb/report/studentAttendanceDetailsForm`, 'get')
}

/**
 * @desc 学校考勤信息列表
 */
export function studentAttendanceList(params) {
  let afterParams = filterEmpty(params)
  return baseRequest(
    `/api/pcWeb/report/studentAttendanceDetails`,
    'get',
    afterParams
  )
}
